import { useParams } from 'react-router-dom'
import { setNavLink, unsetNavLink } from '../../actions/nav'
import { fetchStatusSummary } from '../../actions/status'
import StudentDetails from '../../components/students/coordinator/StudentDetails'
import { isEmpty } from '../../utils/common'

const mapStateToProps = state => {
  const {
    status: { data: status, fetched },
    settingsEducationPeriod: { selectedEducationPeriod },
    user: {
      data: { selectedOrgId },
    },
  } = state
  return {
    selectedOrgId,
    selectedEducationPeriod,
    status,
    fetched,
  }
}

const StudentDetailsPage = ({
  setNavLink,
  unsetNavLink,
  selectedOrgId,
  selectedEducationPeriod,
  status,
  fetched,
  fetchStatusSummary,
}) => {
  const { studentId } = useParams()

  useEffect(() => {
    setNavLink('/students', 'Back to Students')

    // need order status, only fetch if hasn't data doesn't exist
    if (isEmpty(status) && !fetched) {
      fetchStatusSummary(selectedOrgId, selectedEducationPeriod)
    }

    return () => unsetNavLink()
  }, [])

  return (
    <CSSTransition
      classNames="animate-fade"
      in={true}
      timeout={500}
      appear={true}
      enter={false}
      exit={false}
    >
      <div className="container">
        <StudentDetails studentId={studentId} />
      </div>
    </CSSTransition>
  )
}

export default connect(
  mapStateToProps,
  { setNavLink, unsetNavLink, fetchStatusSummary }
)(StudentDetailsPage)
